import themeVariables from "@Theme/exportColor.module.scss";

export default ({ fill = themeVariables.neutral5, width = 20, height = 20 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_475_10423)">
      <path
        d="M9.53843 10.1703C8.13381 9.07111 6.53925 7.40568 5.83001 5.38706C5.24589 3.72457 5.71908 2.46512 6.57227 1.80939C7.43593 1.14561 8.78167 1.02633 10.095 1.84668C10.681 2.21275 11.4401 2.19282 12.013 1.83026C13.2567 1.04316 14.6611 1.1734 15.6019 1.86481C16.5265 2.54433 17.0437 3.79695 16.4504 5.37921C15.7068 7.362 14.0405 9.04742 12.5843 10.169C11.6744 10.8698 10.4373 10.8738 9.53843 10.1703Z"
        fill="#FDC8D3"
        stroke="#1F2A37"
        strokeWidth="0.8"
        strokeLinecap="round"
      />
      <path
        d="M4.39062 12.1445H4.94119C5.59034 12.1445 6.22974 12.3025 6.80418 12.6049L8.24898 13.3653C8.70582 13.6057 9.21431 13.7314 9.73055 13.7314H11.3248C12.2012 13.7314 12.9116 14.4418 12.9116 15.3182L18.0381 12.9348C18.5489 12.6974 19.1565 12.8908 19.4359 13.3799C19.7428 13.9169 19.5387 14.6014 18.9879 14.8828L11.7096 18.6002C10.7219 19.1046 9.56912 19.1764 8.52651 18.7983L6.00849 17.8852C5.57133 17.7266 5.10986 17.6456 4.64484 17.6456H4.39063C3.83834 17.6456 3.39062 17.1978 3.39062 16.6456V13.1445C3.39062 12.5922 3.83834 12.1445 4.39062 12.1445Z"
        fill="white"
      />
      <path
        d="M12.9116 15.3182V15.3182C12.9116 14.4418 12.2012 13.7314 11.3248 13.7314H9.73055C9.21431 13.7314 8.70582 13.6057 8.24898 13.3653L6.80418 12.6049C6.22974 12.3025 5.59034 12.1445 4.94119 12.1445H4.39062C3.83834 12.1445 3.39062 12.5922 3.39062 13.1445V16.6456C3.39062 17.1978 3.83834 17.6456 4.39063 17.6456H4.64484C5.10986 17.6456 5.57133 17.7266 6.00849 17.8852L8.52651 18.7983C9.56912 19.1764 10.7219 19.1046 11.7096 18.6002L18.9879 14.8828C19.5387 14.6014 19.7428 13.9169 19.4359 13.3799V13.3799C19.1565 12.8908 18.5489 12.6974 18.0381 12.9348L12.9116 15.3182ZM12.9116 15.3182H8.15112M8.15112 15.3182C7.93955 15.4416 7.51639 15.8366 7.51639 16.429C7.51639 15.7519 7.93955 15.4064 8.15112 15.3182Z"
        stroke="#1F2A37"
        strokeWidth="0.8"
        fill="white"
        strokeLinecap="round"
      />
      <path
        d="M0.477245 17.4958L0.860204 12.2493C0.883094 11.9357 1.14419 11.693 1.45861 11.693H3.12577C3.45714 11.693 3.72577 11.9616 3.72577 12.293V17.5395C3.72577 17.8709 3.45714 18.1395 3.12577 18.1395H1.07565C0.727077 18.1395 0.451869 17.8435 0.477245 17.4958Z"
        fill="white"
        stroke="#1F2A37"
        strokeWidth="0.8"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_475_10423">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
